import React, { ReactNode } from "react";
import Navbar from "./NavBar";

// Define the type for the children prop
interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div>
      <Navbar />
      <main className="">{children}</main> {/* Add padding here */}
    </div>
  );
};

export default Layout;
